import React from 'react';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  ContentBullet,
  Content,
  Block,
} from 'components/landing/components';

const dumbOffer = dumbBem('l-offer');
const Bullet = tx([{ element: 'bullet' }, dumbOffer])('div');

const SpecList = ({
  specList,
}) => {
  return (
    specList.map((spec, id) => (
      <Block modifier="content" key={id}>
        <ContentBullet title={spec.title} />

        <Content modifier="content">
          {spec.bullets.map((bullet, specId) => <Bullet key={specId}>{bullet}</Bullet>)}
        </Content>
      </Block>
    ))
  );
};

export default SpecList;



// WEBPACK FOOTER //
// ./src/components/landing/pages/offer/SpecList.jsx